/* Keep voucher instructions outside the mobile preview's constrained canvas. */
(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('hh-frame-designer').forEach((designer) => {
      const help = designer.querySelector('[data-voucher-help]');
      const preview = designer.querySelector('.hhd-preview');
      if (!help || !preview || help.dataset.mobilePlaced) return;
      help.dataset.mobilePlaced = 'true';
      const anchor = document.createComment('voucher instructions');
      help.before(anchor);
      const mobile = window.matchMedia('(max-width: 900px)');
      const position = () => {
        if (mobile.matches) preview.after(help);
        else anchor.after(help);
      };
      position();
      mobile.addEventListener('change', position);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
